import axios from 'axios'

const surveyQuestionApiService = {
  // Category list for the Rating Questions list screen (Kinds + question counts)
  getCategories: () => {
    return axios.get('/survey-questions/categories')
      .then(res => res.data.categories || [])
      .catch(() => [])
  },

  // All questions for one category (Kind), including inactive ones
  getQuestions: (kindId) => {
    return axios.get(`/kinds/${kindId}/survey-questions`)
      .then(res => res.data.questions || [])
      .catch(() => [])
  },

  // Replace the whole question set for one category (the Save button)
  saveQuestions: (kindId, questions) => {
    return axios.put(`/kinds/${kindId}/survey-questions`, { questions })
      .then(res => res.data.questions || [])
  }
}

export default surveyQuestionApiService
